import athubAxios from './core'

export { athubAxios }
